module.exports = __webpack_public_path__ + "img/mundobassegameone.93a2490a.png";